export const PAGE_VIEW_STATES = {
  next_few_slots: 'next_few_slots',
  calendar_view: 'calendar_view',
  bundleSelection: 'bundle_selection',
  confirm_slot_choose_payment: 'confirm_slot_choose_payment',
  payUsingGiftCard: 'payUsingGiftCard',
  bookingConfirmation: 'bookingConfirmation',
}

